import service from './baseService';

export const getPassengerPointsService = (vehicleAssignmentId) => {
    return service.get(`/passenger-points`, { params: { vehicleAssignmentId: vehicleAssignmentId } });
};
